import { isValidPhoneNumber } from 'libphonenumber-js';
import * as yup from 'yup';

export const phoneNumberValidation = (extension: string) => {
  return yup.string().test('Validate phone number', 'Must be a valid phone number', (value: string | undefined) => {
    if (value === undefined) {
      return true;
    }
    const phoneNumber = value || '';
    return isValidPhoneNumber(extension + phoneNumber);
  });
};

const WeeklyScheduleTimePairs = yup
  .array()
  .of(yup.object({ startMinutes: yup.number().required(), endMinutes: yup.number().required() }))
  .required();

export const selfServeSignupValidationSchema = yup.object({
  language: yup.string().required(),
  country: yup.string().required(),
  firstName: yup.string().trim().required(),
  lastName: yup.string().trim().required(),
  name: yup.string().trim().required(),
  phoneNumber: yup
    .object({
      extension: yup.string().required(),
      number: yup
        .string()
        .trim()
        .required()
        .when('extension', (extension: string) => phoneNumberValidation(extension)),
    })
    .required(),
  email: yup.string().trim().email().required(),
  venues: yup
    .object({
      name: yup.string().trim().required(),
      address: yup.string().trim().required(),
      postCode: yup.string().trim().required(),
      city: yup.string().trim().required(),
      isWoltCity: yup.boolean().required(),
      otherCity: yup
        .string()
        .trim()
        .when('city', (city: string, schema: yup.StringSchema) => (city === 'other' ? schema.required() : schema))
        .defined(),
      openingHours: yup.object({
        monday: WeeklyScheduleTimePairs,
        tuesday: WeeklyScheduleTimePairs,
        wednesday: WeeklyScheduleTimePairs,
        thursday: WeeklyScheduleTimePairs,
        friday: WeeklyScheduleTimePairs,
        saturday: WeeklyScheduleTimePairs,
        sunday: WeeklyScheduleTimePairs,
      }),
    })
    .required(),
  // TODO: uncomment when website field is added back
  // website: yup
  //   .string()
  //   .trim()
  //   .url('This must be a valid URL')
  //   .test('starts-with-https', 'URL should start with https://', (value: string | undefined) =>
  //     !!value ? value.startsWith('https://') : true,
  //   ),
  businessId: yup.string().trim().required(),
  businessType: yup.string().trim().required(),
});
